<script>
import PageHeader from '../../SettingsSubPageHeader.vue';
import BandwidthSms from './BandwidthSms.vue';
import Twilio from './Twilio.vue';
import OmnupAndroidSms from './OmnupAndroidSms.vue';

export default {
  components: {
    PageHeader,
    Twilio,
    BandwidthSms,
    OmnupAndroidSms,
  },
  data() {
    return {
      // Varsayilan artik kendi telefonu: ucuncu tarafa bagimli
      // olmayan secenegi one aliyoruz.
      provider: 'omnup_android',
    };
  },
};
</script>

<template>
  <div class="h-full w-full p-6 col-span-6">
    <PageHeader
      :header-title="$t('INBOX_MGMT.ADD.SMS.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.SMS.DESC')"
    />
    <div class="flex-shrink-0 flex-grow-0">
      <label>
        {{ $t('INBOX_MGMT.ADD.SMS.PROVIDERS.LABEL') }}
        <select v-model="provider">
          <option value="omnup_android">
            {{ $t('INBOX_MGMT.ADD.SMS.PROVIDERS.OMNUP_ANDROID') }}
          </option>
          <option value="twilio">
            {{ $t('INBOX_MGMT.ADD.SMS.PROVIDERS.TWILIO') }}
          </option>
          <option value="360dialog">
            {{ $t('INBOX_MGMT.ADD.SMS.PROVIDERS.BANDWIDTH') }}
          </option>
        </select>
      </label>
    </div>
    <OmnupAndroidSms v-if="provider === 'omnup_android'" />
    <Twilio v-else-if="provider === 'twilio'" type="sms" />
    <BandwidthSms v-else />
  </div>
</template>
